export const HOME_SEO = {
  title: "Auto Socorro Pedrinho - Guincho 24 Horas em Arujá/SP",
  description: "Serviço de guincho, reboque e socorro mecânico em Arujá e região. Atendimento rápido, seguro e 24 horas pela Rodovia Presidente Dutra e bairros próximos.",
  keywords: "guincho em Arujá, guincho 24 horas em Arujá, reboque em Arujá, auto socorro em Arujá, socorro mecânico em Arujá",
};

export function setHomeSeo() {
  document.title = HOME_SEO.title;
  const description = document.querySelector('meta[name="description"]');
  if (description) description.setAttribute("content", HOME_SEO.description);
}